module.exports = __webpack_public_path__ + "img/B4.2b9dbf78.svg";